import './App.css';
import Header from './Component/Header/Header';
import Exercise from './Component/Exercise/Exercise';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Exercise></Exercise>
    </div>
  );
}

export default App;
